import { useEffect } from 'react';
import { useBoardCoreData } from '../providers/BoardCoreDataProvider';
export const useSyncError = error => {
  const store = useBoardCoreData();
  useEffect(() => {
    var _store$onError;
    store === null || store === void 0 || (_store$onError = store.onError) === null || _store$onError === void 0 || _store$onError.call(store, error);
  }, [error, store]);
};